import _ from 'lodash';

import { getAgencyCode } from 'client/utils/state';

import { Logger } from './clientLogger';
import { GraphqlError } from './errors';

const is401 = status => status === 401;
const is403 = status => status === 403;
const queriesToIgnore = ['BrokerPersonSearch', 'DashboardGetEnrollmentStatus', 'GetIssues'];
const shouldRedirect = (queryName: string) => !queriesToIgnore.includes(queryName);

export const handleGraphqlError = ({ graphQLErrors, operation, networkError }) => {
  let redirectTo401Page = false;
  let redirectTo403Page = false;

  if (graphQLErrors) {
    graphQLErrors.forEach(({ message, extensions }) => {
      const variables = _.get(extensions, 'variables', {});
      const { payload, edePayload, ...metadata } = variables;
      const error = {};
      const status = _.get(extensions, 'response.status');

      error.code = extensions.code;
      error.operationName = operation.operationName;
      error.message = _.get(extensions, 'response.body.message', message);
      error.body = _.get(extensions, 'response.body', {});
      error.variables = metadata;
      error.type = 'graphql';

      if (!__IS_PROD__) {
        /* eslint-disable no-console */
        console.error(`${error.code}: ${error.message}`);
        console.log('%c Additional Apollo Error Info ---> ', 'color: red', error);
        /* eslint-enable no-console */
      }

      Logger.captureException(new GraphqlError(error.message), (scope) => {
        const { agentId, siteConfigs } = window.__INITIAL_STATE__ || {};
        const agencyCode = getAgencyCode(siteConfigs);

        scope.setTag('operationName', error.operationName);
        scope.setTag('userType', agentId ? 'agent' : 'consumer');
        scope.setTag('code', error.code);
        scope.setContext('variables', error.variables);

        if (agencyCode) {
          scope.setTag('agencyCode', agencyCode);
        }

        if (error.operationName) {
          scope.setTransactionName(error.operationName);
        }
      });

      // Still want to print all of the errors before redirecting to unauthorized page;
      if (shouldRedirect(operation.operationName)) {
        if (is401(status)) {
          redirectTo401Page = true;
        } else if (is403(status)) {
          redirectTo403Page = true;
        }
      }
    });
  }

  if (networkError) {
    const statusCode = +_.get(networkError, 'statusCode');

    if (is401(statusCode)) {
      redirectTo401Page = true;
    } else if (is403(statusCode)) {
      redirectTo403Page = true;
    }

    Logger.captureException(networkError);
  }

  if (redirectTo403Page) {
    window.location.replace('/error/403');
  }

  if (redirectTo401Page) {
    const returnUrl = encodeURIComponent(window.location.pathname + window.location.search);
    const { agentId } = window.__INITIAL_STATE__ || {};

    if (agentId) {
      window.location.replace('/enrollment/error/401?error=inactive');
    } else {
      window.location.replace(`/auth/login?returnTo=${returnUrl}`);
    }
  }
};
